import Swiper from "swiper";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

document.addEventListener("DOMContentLoaded", () => {
  // SliderProducts
  document.querySelectorAll(".sliderProducts").forEach((sliderEl) => {
    const type = sliderEl.dataset.sliderType;
    const breakpoints = {
      768: { slidesPerView: 2, spaceBetween: 16 },
      1024: { slidesPerView: type === "images" ? 4 : 3, spaceBetween: 16 },
      1528: { slidesPerView: type === "images" ? 4 : 3, spaceBetween: 16 },
    };

    // Swiper warns + disables loop unless slides.length > slidesPerView + loopAdditionalSlides.
    // Max per view is 4 (images) or 3 (default); +1 for loopAdditionalSlides.
    const maxSlidesPerView = type === "images" ? 4 : 3;
    const slideCount = sliderEl.querySelectorAll(".swiper-slide").length;
    const canLoop = slideCount > maxSlidesPerView + 1;

    new Swiper(sliderEl, {
      modules: [Navigation, Pagination],
      loop: canLoop,
      loopAdditionalSlides: canLoop ? 1 : 0,
      spaceBetween: 16,
      breakpoints,
      navigation: {
        nextEl: sliderEl
          .closest(".slider-products")
          ?.querySelector(".swiper-button-next.prod"),
        prevEl: sliderEl
          .closest(".slider-products")
          ?.querySelector(".swiper-button-prev.prod"),
      },
      pagination: {
        el: sliderEl
          .closest(".slider-products")
          ?.querySelector(".swiper-pagination.prod"),
        clickable: true,
      },
      on: {
        init: () => {
          setTimeout(() => {
            if (window.handleScrollResize) {
              window.handleScrollResize();
            }
          }, 30);
        },
      },
    });

    const matchButtonHeightToSlide = () => {
      const slideImg = sliderEl.querySelector("img");
      const button = sliderEl
        .closest(".slider-products")
        ?.querySelector(".slider-products-buttons > div");
      if (slideImg && button) {
        button.style.height = `${slideImg.offsetHeight}px`;
      }
    };

    window.addEventListener("load", () =>
      setTimeout(matchButtonHeightToSlide, 20)
    );
    window.addEventListener("resize", matchButtonHeightToSlide);
  });

  // BlogSlider
  const blogSlider = document.querySelector(".blogSlider");
  if (blogSlider) {
    new Swiper(blogSlider, {
      modules: [Pagination],
      pagination: {
        el: ".swiper-pagination.blog",
        clickable: true,
      },
    });

    const matchPaginationWidthToImage = () => {
      const img = blogSlider.querySelector(".swiper-slide-active img");
      const pagination = document.querySelector(".swiper-pagination.blog");
      if (img && pagination && window.innerWidth >= 768) {
        pagination.style.setProperty(
          "width",
          `${img.offsetWidth}px`,
          "important"
        );
      }
      pagination?.classList.remove("hidden");
    };

    const positionBlogPaginationMobile = () => {
      if (window.innerWidth >= 768) return;
      const img = blogSlider.querySelector(".swiper-slide-active img");
      const pagination = document.querySelector(".pagination-block");
      if (img && pagination) {
        pagination.style.setProperty("top", `${img.offsetHeight + 40}px`);
      }
    };

    window.addEventListener("load", () => {
      setTimeout(() => {
        matchPaginationWidthToImage();
        positionBlogPaginationMobile();
      }, 20);
    });
    window.addEventListener("resize", () => {
      matchPaginationWidthToImage();
      positionBlogPaginationMobile();
    });
  }

  // Brands Slider
  const screenWidth = window.innerWidth;
  let slidesPerViewBrands = "auto";
  let spaceBetweenBrands = 50;

  if (screenWidth >= 1528) {
    slidesPerViewBrands = 5;
    spaceBetweenBrands = 30;
  } else if (screenWidth >= 1024) {
    slidesPerViewBrands = 5;
  } else if (screenWidth >= 768) {
    slidesPerViewBrands = 4;
    spaceBetweenBrands = 20;
  }

  if (document.querySelector(".sliderBrands")) {
    new Swiper(".sliderBrands", {
      modules: [Pagination, Autoplay],
      slidesPerView: slidesPerViewBrands,
      spaceBetween: spaceBetweenBrands,
      freeMode: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: true,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        768: { slidesPerView: 4, spaceBetween: 20 },
        1024: { slidesPerView: 5, spaceBetween: 20 },
        1528: { slidesPerView: 5, spaceBetween: 30 },
      },
      on: {
        init: () => {
          setTimeout(() => {
            if (window.handleScrollResize) {
              window.handleScrollResize(); // force visibility check after Swiper builds
            }
          }, 30); // wait one animation frame (tweak as needed)
        },
      },
    });
  }
});
